// Generated by CoffeeScript 2.7.0
var FieldListMixin;

export default FieldListMixin = {
  props: ['fields', 'entries', 'extendClass', 'response', 'isAdmin', 'previousFieldVm', 'disappearedFieldIds', 'groupedFields', 'activePageIndex'],
  data: function() {
    return {
      fieldChildren: []
    };
  },
  created: function() {
    return this.$watch('valid', function(newValue) {
      if (this.$parent) {
        return this.$emit('validChange', newValue);
      }
    }, {
      sync: true
    });
  },
  computed: {
    valid: function() {
      return !this.visible || this.fieldChildren.every(function(child) {
        return child.valid;
      });
    }
  },
  methods: {
    displayFirstError: function() {
      var first_group, first_invalid, first_invalid_index;
      first_invalid_index = _.findIndex(this.fieldChildren, function(child) {
        return !child.valid;
      });
      if (first_invalid_index < 0) {
        return;
      }
      first_invalid = this.fieldChildren[first_invalid_index];
      if (first_invalid.field.type === 'Field::Detail') {
        first_group = _.find(first_invalid.groupViewChilden, function(group) {
          return !group.valid;
        });
        if (!first_group) {
          // 所有group都是空group的情况
          first_group = _.first(first_invalid.groupViewChilden);
          if (first_group) {
            first_group.forceValidate();
          }
          setTimeout(() => {
            return this._alertErrorContent(`必填${first_invalid.field.title}至少需要填一个${first_invalid.field.settings.button_name}`);
          }, 1000);
        }
        return first_group != null ? first_group.$refs.groupedFieldList.displayFirstError() : void 0;
      } else {
        return first_invalid.$nextTick(function() {
          return this.focusToCurrent();
        });
      }
    },
    reset: function() {
      return this.fieldChildren.forEach(function(fieldView) {
        return fieldView.reset();
      });
    },
    fieldValueChange: function(field) {
      return this.$emit('valueChange', field);
    },
    getDraftEntries: function() {
      var results;
      results = [];
      _.each(this.fieldChildren, function(child) {
        if (child.field.type === 'Field::Location') {
          return;
        }
        return results = results.concat(_.filter(child.getEntries(true), function(entry) {
          delete entry.id;
          return !entry._destroy;
        }));
      });
      return results;
    },
    getResetEntries: function() {
      var results;
      results = [];
      _.each(this.fieldChildren, function(child) {
        return results = results.concat(child.getResetEntries());
      });
      return results;
    },
    getEntries: function(vaidate_ignore) {
      return _.chain(this.fieldChildren).map(function(fieldView) {
        return fieldView.getEntries(vaidate_ignore);
      }).flatten().map(function(entry) {
        return _.pick(entry, 'id', 'field_id', 'group_id', 'value', 'option_id', 'choice_id', 'value_id', 'longitude', 'latitude', '_destroy');
      }).value();
    },
    _filterEntries: function(field) {
      var _entries, field_id_attr;
      field_id_attr = field.type === 'Field::Detail' ? 'detail_id' : 'field_id';
      _entries = _.filter(this.entries, function(entry) {
        var ref;
        return ((ref = entry[field_id_attr]) != null ? ref.toString() : void 0) === field.id.toString();
      });
      if (this.response.isNew()) {
        switch (field.type) {
          case 'Field::Location':
            return [];
          default:
            return _.map(_entries, function(entry) {
              return _.omit(entry, 'id');
            });
        }
      } else {
        return _entries;
      }
    },
    addChildFunc: function(vm) {
      vm.setPreviousFieldVm(_.isEmpty(this.fieldChildren) ? this.previousFieldVm : _.last(this.fieldChildren));
      return this.fieldChildren.push(vm);
    }
  }
};
